<template>
  <div>
    <v-container fluid>
      <div class="modal-padding myt-modal">
        <div class="close-outer" @click="onClose({status:false})">
          <img src="../../../assets/img/close-icon.svg" class="close-icon" />
        </div>
        <v-row>
          <v-col cols="12" sm="12" class="otp-error-msg">
            <div class="myt-center-name">{{data && data.name ? 'Hello '+ data.name.split(' ')[0] + '!' : 'Hello!'}}</div>
            <div class="account-proceed-text">
              You need to verify your account to proceed
            </div>

            <div class="enter-text-title">
              Please Enter the 6 digit OTP sent to {{ this.data && this.data.phone }}
              <img
                src="../../../assets/img/edit-icon.svg"
                class="edit-myt-icon"
                @click="onClose({...data,status:false,edit:true})"
              />
            </div>
            <otp-input
            mode="separate"
              :isValid="isCodeValid"
              :digits="6"
              @on-complete="inputOtp"
              @on-changed="inputOtp2"
              @on-paste="onPasteHandler">
            </otp-input>
            <InputError :data="error.otp" />

          </v-col>

          <div class="resend-link-outer">
            Didn't Receive OTP? <a :class="!isResendOtp ? 'disabled_resendotp' : ''" @click="resendOtp()">Resend </a><span v-if="timer>0">in {{ timer }} secs</span>
          </div>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12">
            <div class="center-right-alignn">
              <v-btn
                ref="submitBtn"
                class="right-btn cust-btn"
                color="primary"
                @click="submit({...data,status:false,verify_otp:true,otp})"
                >Submit</v-btn
              >
            </div>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import  OtpInput  from  "otp-input-vue2";
let timeInterval;
export default {
  name: "LoginOTP",
  props:['onClose','data'],
  // ptops:['data','onClose'],
  data() {
    return {
      cComponent: "",
      modalwidth: "500px",
      status: false,
      isCodeValid:true,
      otp:[],
      error:{
        otp:{
          type:null,
          message:''
        }
      },
      isResendOtp: false,
      timer: 0
    };
  },
  mounted(){
    this.timer = this.data.resendOtp ? this.data.resendOtp : 60;
    this.setTimerForOtp();
    this.resendOtpTimer();
  },
  destroyed(){
    clearInterval(timeInterval);
  },
  components:{
    OtpInput
  },
  methods: {
    ...mapActions({
      resendOtpMyt: "userStore/resendOtpMyt"
    }),
    submit(data) {
      if (this.handleValidation()) {
        this.onClose(data)
      }
    },
    inputOtp(data) {
      this.otp = data
      this.$nextTick(() => {
        this.$refs.submitBtn.$el.focus();
      });
      // this.status = data.status;
    },
    inputOtp2(data) {
      if (data) {
        this.otp += data
      }else{
        this.otp = this.otp.substring(0,this.otp.length-1)
      }
      
    },
    handleValidation(){
      let valid = true;
      this.error.otp.type= null;
      if (!this.otp || !this.otp.length) {
        this.error.otp.type='error';
        this.error.otp.message='Please Enter otp'
        valid=false;
      }else if(this.otp.length>0 && this.otp.length<6){
        this.error.otp.type='error';
        this.error.otp.message='Please Enter valid otp'
        valid=false;
      }
      this.isCodeValid = valid
      return valid;
    },
    resendOtp(){
      let reqData={
        phone:this.data.phone
      }
      this.resendOtpMyt(reqData).
      then(response=>{
        this.isResendOtp = false;
        this.setTimerForOtp()
        this.timer = 60;
        this.resendOtpTimer();
      })
      .catch(err=>console.log(err))
    },
    onPasteHandler(code){
      this.otp  = code
		},
    resendOtpTimer(){
      timeInterval = setInterval(() => {
        if(this.timer > 0){
          this.timer--;
        }else{
          clearInterval(timeInterval);
        }
      },1000)
    },
    setTimerForOtp(){
      setTimeout(() => {
      this.isResendOtp = true;
    },(this.timer * 1000))
    }
  },
  watch:{
    otp(val){
      
    }
  }
};
</script>
